// extracted by mini-css-extract-plugin
module.exports = {"SM":"360px","MD":"640px","LG":"1200px","Root":"Page_Root__3j9Of","Container":"Page_Container__uUUyt","Content":"Page_Content__3JdHi"};